/**
 * @generated SignedSource<<7e32f40d0b2159cb4cc5cda163426deb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProposalVotesSummaryFragment$data = {
  readonly againstVotes: {
    readonly amount: string;
  };
  readonly forVotes: {
    readonly amount: string;
  };
  readonly quorumVotes: {
    readonly amount: string;
  };
  readonly " $fragmentSpreads": FragmentRefs<"ProposalVotesSummaryVoteTimeFragment" | "ProposalVotesSummaryVotesBarFragment">;
  readonly " $fragmentType": "ProposalVotesSummaryFragment";
};
export type ProposalVotesSummaryFragment$key = {
  readonly " $data"?: ProposalVotesSummaryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProposalVotesSummaryFragment">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "amount",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProposalVotesSummaryFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TokenAmount",
      "kind": "LinkedField",
      "name": "forVotes",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TokenAmount",
      "kind": "LinkedField",
      "name": "againstVotes",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TokenAmount",
      "kind": "LinkedField",
      "name": "quorumVotes",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProposalVotesSummaryVotesBarFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProposalVotesSummaryVoteTimeFragment"
    }
  ],
  "type": "OnChainProposal",
  "abstractKey": null
};
})();

(node as any).hash = "4af83dd469df25b74011ada9e7c8e8c8";

export default node;
